module.exports = __webpack_public_path__ + "img/roleModels@2x.ad6938de.png";